import styled from 'styled-components'

const BottomLeft = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: 35px;
  left: 35px;
`

export default BottomLeft
